import DOMPurify from "dompurify";
import { filterXSS } from "xss";

export type SanitizerType = "html" | "svg";

export class Sanitizer {
  static svg(html: string) {
    return DOMPurify.sanitize(html, { USE_PROFILES: { svg: true } });
  }

  static html(html: string) {
    return filterXSS(html, { onIgnoreTagAttr: (_tag, name, value, _isWhiteAttr) => name + '="' + value + '"' });
  }

  static sanitize(html: string, sanitizer: SanitizerType = "html") {
    switch (sanitizer) {
      case "svg": return Sanitizer.svg(html);
      case "html":
        return Sanitizer.html(html);
    }
    return html;
  }
}